export default __webpack_public_path__ + "static/SEO_image-27965593b26df4272354d84f775af1b6.png";